import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import ModelDataSourcePropertyBase from "./ModelDataSourcePropertyBase";
import ModelDataSourceServiceOtherParamsProperty from "./ModelDataSourceServiceOtherParamsProperty";

import { FetchHelper } from "@yulintu/freesia-core";

import { parseQueryResultToCommonResult } from '../utils/helper';

import ModelDataSourceServiceParamProperty from "./ModelDataSourceServiceParamProperty";

export default class Model extends ModelDataSourcePropertyBase {

    url = new PropertyDescriptor('/data/samples/HeightWeight.json', '服务地址', '高级', 'text', "#anticon-link", {
        style: { fontSize: 13 },
    });

    type = new PropertyDescriptor('GET', '请求类型', "高级", "enum", "#anticon-speed", {
        values: [
            new PropertyDescriptor("GET"),
            new PropertyDescriptor("POST"),
            new PropertyDescriptor("PUT"),
            new PropertyDescriptor("DELETE"),
        ],
    });

    params = new PropertyDescriptor([], '请求数据', "高级", "objects", "#anticon-jichubiaoge", {
        description: "配置请求网络服务的时要传入的数据",
        modelTemplate: ModelDataSourceServiceParamProperty,
    });

    others = new PropertyDescriptor(new ModelDataSourceServiceOtherParamsProperty({
        fetchParamsExpression: "", resultsExpression: `const list = [];
data.男.map(c => list.push({
    性别: "男",
    身高: c[0],
    体重: c[1]
}));
data.女.map(c => list.push({
    性别: "女",
    身高: c[0],
    体重: c[1]
}));
list;` }), '其他设置', "高级", "object", "#anticon-profile-setting", {
        valueTemplate: ModelDataSourceServiceOtherParamsProperty,
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    onPropertyValueChanged(name, valOld, valNew) {

    }

    loadData(opts) {
        return new Promise((resolve, reject) => {
            if (!this.url) {
                resolve(null);
                return;
            }
            let url = this.url;
            let params = {};
            (this.params || []).forEach(param => {
                params[param.name] = param.getValue({ runScript: opts.runScript });
            });

            let fetchParams = this.others.getFetchParams({ runScript: opts.runScript });

            let api = this.getMethod();
            api(url, params, fetchParams)
                .then(baseData => {
                    let results = this.others.getResults(baseData, { runScript: opts.runScript, lastData: opts.lastData });
                    let data = parseQueryResultToCommonResult(results);
                    resolve(data);
                    // resolve(data);

                }).catch(err => {
                    reject(err);
                })
        })
    }

    getMethod() {
        const type = this.type;
        if (type === "GET")
            return FetchHelper.getJson.bind(FetchHelper);
        if (type === "POST")
            return FetchHelper.postJson.bind(FetchHelper);
        if (type === "PUT")
            return FetchHelper.putJson.bind(FetchHelper);
        if (type === "DELETE")
            return FetchHelper.deleteJson.bind(FetchHelper);
    }
}
